import axios from 'axios'
import { API_URL, CLIENT_ID } from '@/config'
import store from '@/store'
import Vue from 'vue'
import getHeaders from './headers'

// Setup base config. API endpoint and auth headers
const instance = axios.create({
  baseURL: API_URL,
  headers: getHeaders()
})

instance.reloadHeaders = () => {
  instance.defaults.headers = getHeaders()
}

instance.interceptors.request.use(request => {
  if ((new Date()).getTime() + 60000 > store.getters['auth/tokens'].expires_in) {
    return new Promise((resolve, reject) => {
      var newWindow = window.open(
        `${API_URL}auth?client_id=${CLIENT_ID}&redirect_uri=${window.location.origin}/login&response_type=token`,
        'Login',
        'height=600, width=450'
      )

      if (newWindow) {
        newWindow.focus()
        window.addEventListener('message', function (e) {
          if (e.data.source !== 'login-token') {
            return
          }
          store.commit('auth/SET', e.data.payload)
          instance.reloadHeaders()
          request.headers = instance.defaults.headers
          resolve(request)
        })
      } else {
        resolve(request)
      }
    })
  }
  return request
})

instance.sendRequests = requests => {
  let promises = []
  for (const request of requests) {
    let dataConfig = request.data ? [request.data, request.config] : [request.config]
    promises.push(
      instance[request.method](request.url, ...dataConfig)
        .then(exchange => ({ successful: true, response: exchange, userRequest: request }))
        .catch(exchange => ({ successful: false, response: exchange, userRequest: request }))
    )
  }
  // return Promise.allSettled(promises) // Can be used when 'allSettled' is widely supported
  return Promise.all(promises).then(
    // show ok or error
    promises => {
      let errors = []
      let allGet = true
      for (const exchange of promises) {
        let response = exchange.response.response
        let request = exchange.response.request
        let config = exchange.response.config
        if (config.method !== 'get') {
          allGet = false
        }
        if (exchange.successful === false) {
          if (!request) {
            request = {
              status: 200
            }
          }
          if (!response) {
            response = {
              data: ''
            }
          }
          if (request.status !== 404 && request.status !== 403 && response.data && response.data.length > 0) {
            errors = response.data
          }
          errors.forEach(error => {
            Vue.toasted.showError(error.message)
          })
        }
      }
      if (!errors.length && !allGet) {
        Vue.toasted.showSuccess('OK')
      }
      return promises
    }
  )
}

export default instance
